import { myCareerPlanTranslate } from '../../../i18n/translatedMessages'
import { FaEdit, FaRegTrashAlt } from 'react-icons/fa'
import { GoArrowSwitch, GoArrowUp, GoArrowDown } from 'react-icons/go'

const TableRow = ({ area_id, level_id, subarea_id, id, lists, setModalOpen, setSelectedData, onDelete, employee_level }) => {
	const { areas, levels, subareas } = lists

	const jobName = (level_id, levels, subareas, subarea_id) => {
		const levelName = levels.find(level => level.id === level_id)?.value || ''
		const subareaName = subareas.find(subarea => subarea.id === subarea_id)?.value || ''
		return `${levelName} de ${subareaName}`
	}

	const status = level_id > employee_level ? 'up' : 'default'

	const handleEditClick = () => {
		setSelectedData({ area_id, level_id, subarea_id, id })
		setModalOpen(true)
	}

	const handleDeleteClick = () => {
		onDelete(id)
	}
	return (
		<>
			<tr>
				<td className='tw-px-4 tw-py-2 tw-border-y tw-border-gray-200 tw-text-center'>
					<span className='tw-inline-flex tw-h-8 tw-w-8 tw-rounded-full tw-bg-purple-50 tw-items-center tw-justify-center'>
						{status === 'up' ? <GoArrowUp className='tw-text-purple-600' /> : <GoArrowSwitch className='tw-text-purple-600' />}
					</span>
				</td>
				<td className='tw-px-4 tw-py-2 tw-border-y tw-border-gray-200 '>{jobName(level_id, levels, subareas, subarea_id)}</td>
				<td className='tw-px-4 tw-py-2 tw-border-y tw-border-gray-200 '>{levels.find(level => level.id === level_id)?.value}</td>
				<td className='tw-px-4 tw-py-2 tw-border-y tw-border-gray-200 '>{areas.find(area => area.id === area_id)?.value}</td>
				<td className='tw-px-4 tw-py-2 tw-border-y tw-border-gray-200 tw-flex tw-space-x-2'>
					<button
						className='tw-flex tw-h-8 tw-border-none tw-w-8 tw-rounded-full tw-bg-gray-100 tw-items-center tw-justify-center'
						onClick={handleEditClick}
					>
						<FaEdit className='tw-text-gray-600' />
					</button>
					<button
						className='tw-flex tw-h-8 tw-w-8 tw-border-none tw-rounded-full tw-bg-error-100 tw-items-center tw-justify-center'
						onClick={handleDeleteClick}
					>
						<FaRegTrashAlt className='tw-text-error-600' />
					</button>
				</td>
			</tr>
		</>
	)
}

const MyCareerPlanTable = ({ setModalOpen, setSelectedData, data, lists, onDelete, employee_level }) => {
	return (
		<>
			<table className='tw-min-w-full tw-table-auto'>
				<thead className='tw-border tw-border-gray-200'>
					<tr>
						<th className='tw-px-5 tw-py-3 tw-border-gray-200 tw-text-left  tw-bg-gray-100 tw-font-bold tw-items-center'></th>
						<th className='tw-px-5 tw-py-3 tw-border-gray-200 tw-text-left  tw-bg-gray-100 tw-font-bold '>
							{myCareerPlanTranslate.myCareerPlanColName}
						</th>
						<th className='tw-px-5 tw-py-3 tw-border-gray-200 tw-text-left  tw-bg-gray-100 tw-font-bold '>
							{myCareerPlanTranslate.myCareerPlanColNivel}
						</th>
						<th className='tw-px-5 tw-py-3 tw-border-gray-200 tw-text-left  tw-bg-gray-100 tw-font-bold '>
							{myCareerPlanTranslate.myCareerPlanColArea}
						</th>
						<th className='tw-px-5 tw-py-3 tw-border-gray-200 tw-text-left  tw-bg-gray-100 tw-font-bold '>
							{myCareerPlanTranslate.myCareerPlanColActions}
						</th>
					</tr>
				</thead>
				<tbody className='tw-border tw-border-gray-200'>
					{data.map((item, index) => (
						<TableRow
							key={index}
							{...item}
							lists={lists}
							setModalOpen={setModalOpen}
							setSelectedData={setSelectedData}
							onDelete={onDelete}
							employee_level={employee_level}
						/>
					))}
				</tbody>
			</table>
		</>
	)
}

export default MyCareerPlanTable
